export default {
  install(Vue) {
    Vue.prototype.$urunResim = {
      ilkResim: function(resimler) {
        if (resimler !== null) {
          for (let index = 0; index < 1; index++) {
            let resim = resimler[Object.keys(resimler)[0]][0];
            if (resim !== undefined) {
              return resim;
            } else return this.defaultResim;
          }
        } else return this.defaultResim;
      },
      defaultResim: "shoe.png"
    };

    Vue.prototype.$formatFiyat = (fiyat) => {
      const formatter = new Intl.NumberFormat("tr-TR", {
        style: "currency",
        currency: "TRY"
      });
      return formatter.format(fiyat);
    };
  }
};
